module.exports = __webpack_public_path__ + "img/8.309b8a0f.webp";